module.exports = __webpack_public_path__ + "static/media/sh.5e5280da.png";